<template>
    <modal ref="modal">
        <div id="sub-wrapper">
            <div class="title">{{ $t('modals.contribution_invite.title') }}</div>
            <div class="imgs">
              <img :src="avatarUrl"/>
              <img src="~@/assets/img/avatar_unknown.png"/>
            </div>
            <form @submit="submit">
              <div>
                  <label>{{ $t('labels.email') }} <span>*</span></label>
                  <input ref="email" v-model="email" type="text" :class="error ? 'error' : ''"/>
                  <div class="error" v-if="error">{{ error }}</div>
              </div>
              <button>{{ $t('modals.contribution_invite.button') }}</button>
            </form>
        </div>
    </modal>
</template>

<script>
import event from '@/services/event'

export default {
  data () {
    return {
      avatarUrl: '',
      contribution: {},
      email: '',
      error: '',
      eventID: null
    }
  },
  methods: {
    show (eventID, contribution, avatarUrl) {
      this.avatarUrl = avatarUrl
      this.contribution = contribution
      this.email = ''
      this.error = ''
      this.eventID = eventID
      this.$refs.modal.show()
      this.$nextTick(function () {
        this.$refs.email.focus()
      }.bind(this))
    },
    hide () {
      this.$refs.modal.hide()
    },
    submit (e) {
      // Prevent default
      e.preventDefault()

      // Reset error
      this.error = ''

      // Check email
      if (!this.email || this.email === '') {
        // Update error
        this.error = this.$i18n.t('mandatory.email')
        return
      }

      // Show loader
      this.$parent.$parent.$parent.$refs.loader.show()

      // Invite
      event.createInvitation(this.eventID, this.contribution.id, this.email)
        .then(data => {
          // Hide loader
          this.$parent.$parent.$parent.$refs.loader.hide()

          // Hide modal
          this.hide()

          // Toast
          this.$parent.$parent.$parent.$refs.toaster.success(data.message)
        })
        .catch(err => {
          // Hide loader
          this.$parent.$parent.$parent.$refs.loader.hide()

          // Update error
          this.error = err
        })
    }
  }
}
</script>

<style scoped>

#sub-wrapper {
  width: 25em;
}

#sub-wrapper .title {
  margin-bottom: 1em;
}

#sub-wrapper .imgs {
  margin-bottom: 1.5em;
}

#sub-wrapper .imgs img {
  height: 10em;
  position: relative;
}

#sub-wrapper .imgs img:first-child {
  right: -0.5em;
  z-index: 1;
}

#sub-wrapper .imgs img:last-child {
  left: -0.5em;
}

</style>
